import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { twilioRoutingSubGroup } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchRoutingSubGroup(): Promise<APIResult> {
  const response = await fetch(twilioRoutingSubGroup, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<{
    Name: string;
    Description: string;
    Id: number;
  }>;
};

type TResult = Array<{
  label: string;
  value: number;
  description: string;
}>;

function useGetTwilioRoutingSubGroup(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_twilio_routing_sub_groups',
    async () => {
      const fetchResponse = await fetchRoutingSubGroup();
      const result = fetchResponse?.Data?.map(item => ({
        value: item.Id,
        label: `${item.Name}`,
        description: `${item.Description}`,
      }));
      result.unshift({ value: -1, label: 'Select one', description: '' });
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetTwilioRoutingSubGroup };
